<div class="container">
  <div class="content">
    <!-- Level of Detail -->
    <div class="setting-group">
      <div class="setting-row">
        <div class="setting-label">
          {{ 'MINUTES_STYLING.LEVEL_OF_DETAIL' | translate }}
          <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.LEVEL_OF_DETAIL_DESCRIPTION' | translate"> </mat-icon>
        </div>
        <div class="radio-group">
          @for (option of verbosenesOptions; track option.value) {
            <div
              class="radio-option"
              [class.active]="data.minutesVerboseness === option.value"
              [class.disabled]="disabled"
              (click)="!disabled && selectRadioOption('minutesVerboseness', option.value)"
            >
              {{ option.label | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <!-- Voice -->
    <div class="setting-group">
      <div class="setting-row">
        <div class="setting-label">
          {{ 'MINUTES_STYLING.GRAMMATICAL_VOICE' | translate }}
          <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.GRAMMATICAL_VOICE_DESCRIPTION' | translate"> </mat-icon>
        </div>
        <div class="radio-group">
          @for (option of voiceOptions; track option.value) {
            <div
              class="radio-option"
              [class.active]="data.minutesPassive === option.value"
              [class.disabled]="disabled"
              (click)="!disabled && selectRadioOption('minutesPassive', option.value)"
            >
              {{ option.label | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <!-- Attribution -->
    <div class="setting-group">
      @if (attendeeListHasMembersAndNonMembers) {
        <!-- Attendee Attribution -->
        <div class="setting-row">
          <div class="setting-label">
            {{ 'MINUTES_STYLING.ATTENDEE_ATTRIBUTION' | translate }}
            <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.ATTENDEE_ATTRIBUTION_DESCRIPTION' | translate"></mat-icon>
          </div>
          <div class="radio-group">
            @for (option of attributionOptions; track option.value) {
              <div
                class="radio-option"
                [class.active]="data.minutesAnonymizationAttendees === option.value"
                [class.disabled]="disabled"
                (click)="!disabled && selectRadioOption('minutesAnonymizationAttendees', option.value)"
              >
                {{ option.label | translate }}
              </div>
            }
          </div>
        </div>

        @if (!isAttendeeAnonymizationActive) {
          <div class="nested-section">
            @if (namingDisabled) {
              <div class="warning-message">
                <mat-icon class="warning-icon" fontIcon="warning"></mat-icon>
                <span>{{ 'MINUTES_STYLING.NAMING_DISABLED_WARNING' | translate }}</span>
              </div>
            } @else {
              <div class="setting-row">
                <div class="setting-label">
                  {{ 'MINUTES_STYLING.NAME_DISPLAY_FORMAT' | translate }}
                </div>
                <div class="dropdown-container">
                  @if (showAttendeeHonorificWarning) {
                    <mat-icon class="honorific-warning-icon" [matTooltip]="'MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate">warning</mat-icon>
                  }
                  <div
                    class="dropdown"
                    [class.open]="attendeeNameFormatDropdownOpen"
                    [class.disabled]="disabled"
                    [class.warning]="showAttendeeHonorificWarning"
                  >
                    <div class="dropdown-trigger" (click)="!disabled && toggleAttendeeDropdown()">
                      <span>{{ getSelectedAttendeeNameFormat().label | translate }}</span>
                      <span class="dropdown-arrow">▼</span>
                    </div>
                    @if (attendeeNameFormatDropdownOpen) {
                      <div class="dropdown-menu">
                        @for (format of nameFormats; track format.value) {
                          <div
                            class="dropdown-item"
                            [class.disabled]="isNameFormatDisabled(format)"
                            [matTooltip]="isNameFormatDisabled(format) ? ('MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate) : ''"
                            (click)="!isNameFormatDisabled(format) && selectAttendeeNameFormat(format)"
                          >
                            {{ format.label | translate }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="sublabel">{{ 'MINUTES_STYLING.EXAMPLE' | translate }}: "{{ getSelectedAttendeeNameFormat().example | translate }}"</div>
            }
          </div>
        } @else {
          <div class="nested-section">
            <div class="setting-row">
              <div class="setting-label">
                {{ 'MINUTES_STYLING.ATTRIBUTION_STYLE' | translate }}
              </div>
              <div class="radio-group">
                @for (option of attributionStyleOptions; track option.value) {
                  <div
                    class="radio-option"
                    [class.active]="data.minutesAttributionAttendees === option.value"
                    [class.disabled]="disabled"
                    (click)="!disabled && selectRadioOption('minutesAttributionAttendees', option.value)"
                  >
                    {{ option.label | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Member Attribution -->
        <div class="setting-row">
          <div class="setting-label">
            {{ 'MINUTES_STYLING.MEMBER_ATTRIBUTION' | translate }}
            <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.MEMBER_ATTRIBUTION_DESCRIPTION' | translate"></mat-icon>
          </div>
          <div class="radio-group">
            @for (option of attributionOptions; track option.value) {
              <div
                class="radio-option"
                [class.active]="data.minutesAnonymizationMembers === option.value"
                [class.disabled]="disabled"
                (click)="!disabled && selectRadioOption('minutesAnonymizationMembers', option.value)"
              >
                {{ option.label | translate }}
              </div>
            }
          </div>
        </div>

        @if (!isMemberAnonymizationActive) {
          <div class="nested-section">
            @if (namingDisabled) {
              <div class="warning-message">
                <mat-icon class="warning-icon" fontIcon="warning"></mat-icon>
                <span>{{ 'MINUTES_STYLING.NAMING_DISABLED_WARNING' | translate }}</span>
              </div>
            } @else {
              <div class="setting-row">
                <div class="setting-label">
                  {{ 'MINUTES_STYLING.NAME_DISPLAY_FORMAT' | translate }}
                </div>
                <div class="dropdown-container">
                  @if (showMemberHonorificWarning) {
                    <mat-icon class="honorific-warning-icon" [matTooltip]="'MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate">warning</mat-icon>
                  }
                  <div class="dropdown" [class.open]="memberNameFormatDropdownOpen" [class.disabled]="disabled" [class.warning]="showMemberHonorificWarning">
                    <div class="dropdown-trigger" (click)="!disabled && toggleMemberDropdown()">
                      <span>{{ getSelectedMemberNameFormat().label | translate }}</span>
                      <span class="dropdown-arrow">▼</span>
                    </div>
                    @if (memberNameFormatDropdownOpen) {
                      <div class="dropdown-menu">
                        @for (format of nameFormats; track format.value) {
                          <div
                            class="dropdown-item"
                            [class.disabled]="isNameFormatDisabled(format)"
                            [matTooltip]="isNameFormatDisabled(format) ? ('MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate) : ''"
                            (click)="!isNameFormatDisabled(format) && selectMemberNameFormat(format)"
                          >
                            {{ format.label | translate }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="sublabel">{{ 'MINUTES_STYLING.EXAMPLE' | translate }}: "{{ getSelectedMemberNameFormat().example | translate }}"</div>
            }
          </div>
        } @else {
          <div class="nested-section">
            <div class="setting-row">
              <div class="setting-label">
                {{ 'MINUTES_STYLING.ATTRIBUTION_STYLE' | translate }}
              </div>
              <div class="radio-group">
                @for (option of attributionStyleOptions; track option.value) {
                  <div
                    class="radio-option"
                    [class.active]="data.minutesAttributionMembers === option.value"
                    [class.disabled]="disabled"
                    (click)="!disabled && selectRadioOption('minutesAttributionMembers', option.value)"
                  >
                    {{ option.label | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="setting-row">
          <div class="setting-label">
            {{ 'MINUTES_STYLING.ATTRIBUTION' | translate }}
            <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.ATTRIBUTION_DESCRIPTION' | translate"></mat-icon>
          </div>
          <div class="radio-group">
            @for (option of attributionOptions; track option.value) {
              <div
                class="radio-option"
                [class.active]="data.minutesAnonymization === option.value"
                [class.disabled]="disabled"
                (click)="!disabled && selectRadioOption('minutesAnonymization', option.value)"
              >
                {{ option.label | translate }}
              </div>
            }
          </div>
        </div>

        @if (!isAnonimizationActive) {
          <div class="nested-section">
            @if (namingDisabled) {
              <div class="warning-message">
                <mat-icon class="warning-icon" fontIcon="warning"></mat-icon>
                <span>{{ 'MINUTES_STYLING.NAMING_DISABLED_WARNING' | translate }}</span>
              </div>
            } @else {
              <div class="setting-row">
                <div class="setting-label">
                  {{ 'MINUTES_STYLING.NAME_DISPLAY_FORMAT' | translate }}
                </div>
                <div class="dropdown-container">
                  @if (showHonorificWarning) {
                    <mat-icon class="honorific-warning-icon" [matTooltip]="'MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate">warning</mat-icon>
                  }
                  <div class="dropdown" [class.open]="nameFormatDropdownOpen" [class.disabled]="disabled" [class.warning]="showHonorificWarning">
                    <div class="dropdown-trigger" (click)="!disabled && toggleDropdown()">
                      <span>{{ getSelectedNameFormat().label | translate }}</span>
                      <span class="dropdown-arrow">▼</span>
                    </div>
                    @if (nameFormatDropdownOpen) {
                      <div class="dropdown-menu">
                        @for (format of nameFormats; track format.value) {
                          <div
                            class="dropdown-item"
                            [class.disabled]="isNameFormatDisabled(format)"
                            [matTooltip]="isNameFormatDisabled(format) ? ('MINUTES_STYLING.HONORIFIC_DISABLED_TOOLTIP' | translate) : ''"
                            (click)="!isNameFormatDisabled(format) && selectNameFormat(format)"
                          >
                            {{ format.label | translate }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="sublabel">{{ 'MINUTES_STYLING.EXAMPLE' | translate }}: "{{ getSelectedNameFormat().example | translate }}"</div>
            }
          </div>
        } @else {
          <div class="nested-section">
            <div class="setting-row">
              <div class="setting-label">
                {{ 'MINUTES_STYLING.ATTRIBUTION_STYLE' | translate }}
              </div>
              <div class="radio-group">
                @for (option of attributionStyleOptions; track option.value) {
                  <div
                    class="radio-option"
                    [class.active]="data.minutesAttribution === option.value"
                    [class.disabled]="disabled"
                    (click)="!disabled && selectRadioOption('minutesAttribution', option.value)"
                  >
                    {{ option.label | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      }
    </div>

    @if (showBoardMemberLabelling) {
      <div class="section-divider"></div>

      <!-- Board Member Labelling -->
      <div class="setting-group">
        <div class="setting-row">
          <div class="setting-label">
            {{ 'MINUTES_STYLING.BOARD_MEMBER_LABELLING' | translate }}
            <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.BOARD_MEMBER_LABELLING_DESCRIPTION' | translate"> </mat-icon>
          </div>
          <div class="radio-group">
            @for (option of boardMemberLabellingOptions; track option.value) {
              <div
                class="radio-option"
                [class.active]="data.boardMemberLabelling === option.value"
                [class.disabled]="disabled"
                (click)="!disabled && selectRadioOption('boardMemberLabelling', option.value)"
              >
                {{ option.label | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="section-divider"></div>

    <!-- Date Convention -->
    <div class="setting-group">
      <div class="setting-row">
        <div class="setting-label">
          {{ 'MINUTES_STYLING.DATE_CONVENTION' | translate }}
          <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.DATE_CONVENTION_DESCRIPTION' | translate"> </mat-icon>
        </div>
        <div class="radio-group date-formats">
          @for (format of dateFormats; track format.value) {
            <div
              class="radio-option"
              [class.active]="data.minutesDateFormat === format.value"
              [class.disabled]="disabled"
              (click)="!disabled && selectRadioOption('minutesDateFormat', format.value)"
            >
              {{ format.label | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <!-- Time Convention -->
    <div class="setting-group">
      <div class="setting-row">
        <div class="setting-label">
          {{ 'MINUTES_STYLING.TIME_CONVENTION' | translate }}
          <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.TIME_CONVENTION_DESCRIPTION' | translate"> </mat-icon>
        </div>
        <div class="radio-group">
          @for (format of timeFormats; track format.value) {
            <div
              class="radio-option"
              [class.active]="data.minutesTimeFormat === format.value"
              [class.disabled]="disabled"
              (click)="!disabled && selectRadioOption('minutesTimeFormat', format.value)"
            >
              {{ format.label | translate }}
            </div>
          }
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <!-- Language -->
    <div class="setting-group">
      <div class="setting-row">
        <div class="setting-label">
          {{ 'MINUTES_STYLING.LANGUAGE' | translate }}
          <mat-icon class="info-icon" fontIcon="info" [matTooltip]="'MINUTES_STYLING.LANGUAGE_DESCRIPTION' | translate"> </mat-icon>
        </div>
        <div class="radio-group">
          @for (format of languageOptions; track format.value) {
            <div
              class="radio-option"
              [class.active]="data.minutesLanguage === format.value"
              [class.disabled]="disabled"
              (click)="!disabled && selectRadioOption('minutesLanguage', format.value)"
            >
              {{ format.label | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (nameFormatDropdownOpen || memberNameFormatDropdownOpen || attendeeNameFormatDropdownOpen) {
  <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
}
